export const message = {
  language: 'English'
}



// WEBPACK FOOTER //
// ./src/i18n/en/index.js